<template>
  <div>
    <v-card outlined>
      <v-toolbar color="blue-grey  lighten-5" dense>
        <div style="width: 130px">
          <v-select
            dense
            hide-details="true"
            item-text="name"
            item-value="value"
            :items="mode_items"
            v-model="mode"
            class="text-subtitle-1"
            style="margin-top: 5px"
          ></v-select>
        </div>
        <v-spacer></v-spacer>
        <template v-if="mode == 'folder'">
          <v-tooltip bottom v-if="cancreate">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" icon v-on="on" @click="openCreateFolderDialog" small>
                <v-icon>create_new_folder</v-icon>
              </v-btn>
            </template>
            <span>新建目录</span>
          </v-tooltip>
          <v-tooltip bottom v-if="canedit">
            <template v-slot:activator="{ on }">
              <v-btn
                color="green"
                small
                icon
                v-on="on"
                @click.native.stop="openEditFolderDialog"
                :disabled="!selected_folder"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>编辑目录</span>
          </v-tooltip>
          <v-tooltip bottom v-if="candelete">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                color="error"
                icon
                v-on="on"
                @click.native.stop="deleteFoleder"
                :disabled="!selected_folder"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>删除目录</span>
          </v-tooltip>
        </template>
      </v-toolbar>
      <c-folder-tree v-if="mode == 'folder'" :vh="vh"></c-folder-tree>
      <div v-else :style="{ height: vh - 65 + 'px', overflow: 'auto' }">
        <v-treeview
          v-if="category_data && category_data.length"
          class="folder-tree"
          hoverable
          open-all
          activatable
          :active.sync="active_categories"
          :items="category_data"
          dense
          active-class="folder-tree-active"
        ></v-treeview>
      </div>
    </v-card>
    <folder-edit-dialog ref="_folder_dialog"></folder-edit-dialog>
  </div>
</template>
<script>
import { mapState, mapWritableState } from "pinia";
import { useFolderStore } from "@/stores/folderStore.js";
export default {
  name: "ArchiveNavPanel",
  props: ["vh", "cancreate", "canedit", "candelete"],
  data() {
    return {
      mode: "folder",
      mode_items: [
        { name: "档案目录", value: "folder" },
        { name: "实体分类", value: "category" },
      ],
      category_data: [],
      category_loading: false,
      active_categories: [],
    };
  },
  computed: {
    ...mapState(useFolderStore, ["selected_folder"]),
    ...mapWritableState(useFolderStore, ["active_folders"]),
  },
  watch: {
    mode: {
      handler(m) {
        this.$emit("mode-change", m);
        if (m == "category") {
          this.loadCategories();
          //进入实体分类模式时重发当前选中分类，保证案卷列表同步
          this.emitCategoryChange();
        }
      },
    },
    active_categories: {
      handler() {
        this.emitCategoryChange();
      },
    },
  },
  mounted() {},
  methods: {
    loadCategories() {
      if (this.category_loading || (this.category_data && this.category_data.length))
        return;
      this.category_loading = true;
      this.$hc
        .req()
        .get(`categoriestree?type=0`)
        .go({
          lock: true,
          toastError: true,
          toastSuccess: "",
        })
        .subscribe(
          (x) => {
            this.category_data = x.Data;
            this.category_loading = false;
          },
          (x) => {
            this.category_loading = false;
          }
        );
    },
    emitCategoryChange() {
      var catno = "";
      if (this.active_categories && this.active_categories.length) {
        var node = this.$g.treeFindOne(this.active_categories[0], this.category_data);
        if (node && node.value) {
          catno = node.value;
        }
      }
      this.$emit("category-change", catno);
    },
    openCreateFolderDialog() {
      var config = {
        type: 0,
        folder: {
          id: 0,
          rules: [],
        },
      };
      const folderStore = useFolderStore();
      if (folderStore.selected_folder) {
        config.folder.id = folderStore.selected_folder;
      }
      this.$refs._folder_dialog.openDialog(config);
    },
    openEditFolderDialog() {
      var config = {
        type: 0,
        folder: {
          id: 0,
          rules: [],
        },
      };
      config.type = 1;
      const folderStore = useFolderStore();
      config.folder = folderStore.getSelectedNodeCopy();
      this.$refs._folder_dialog.openDialog(config);
    },
    deleteFoleder() {
      const folderStore = useFolderStore();
      if (!folderStore.selected_folder) return;
      this.$confirm("确定要删除这个目录吗? 该目录及其子目录都将被删除").then((x) => {
        if (x) {
          folderStore.delete();
        }
      });
    },
  },
};
</script>
